import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import { getToken } from "../../utils/localStorageMethods";

const apiUrl = config.Url;

const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/ai`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", "true");
    }
    return headers;
  },
});

export const aiSlice = createApi({
  reducerPath: "aiSlice",
  baseQuery,
  tagTypes: ["aiHistory"],
  endpoints: (builder) => ({
    // POST /api/v2/ai/chat
    sendAIMessage: builder.mutation({
      query: (body) => ({
        url: "/chat",
        method: "POST",
        body,
      }),
      invalidatesTags: ["aiHistory"],
    }),

    // GET /api/v2/ai/history
    getAIHistory: builder.query({
      query: (limit = 30) => `/history?limit=${limit}`,
      providesTags: ["aiHistory"],
    }),

    // DELETE /api/v2/ai/history
    deleteAIHistory: builder.mutation({
      query: () => ({ url: "/history", method: "DELETE" }),
      invalidatesTags: ["aiHistory"],
    }),
  }),
});

export const {
  useSendAIMessageMutation,
  useGetAIHistoryQuery,
  useDeleteAIHistoryMutation,
} = aiSlice;
